import { render } from "./SecondaryButton.vue?vue&type=template&id=023c559e"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__